import React, { useState, useEffect } from 'react';
import './App.css';

import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import Gallery from './components/Gallery';
import Contact from './components/Contact';
import Footer from './components/Footer';

import Login from './components/Login';
import AdminPanel from './components/AdminPanel';

import { isAuthenticated } from './services/authService';

function App() {
  const [isAuth, setIsAuth] = useState(false);
  const [view, setView] = useState('public'); 
  // public | login | admin

  useEffect(() => {
    if (isAuthenticated()) {
      setIsAuth(true);
    }
  }, []);

  // 👉 Click en botón Admin
  const handleAdminClick = () => {
    if (isAuthenticated()) {
      setIsAuth(true);
      setView('admin');
    } else {
      setView('login');
    }
  };

  // 👉 Login exitoso
  const handleLoginSuccess = () => {
    setIsAuth(true);
    setView('admin');
  };

  // 👉 Logout
  const handleLogout = () => {
    setIsAuth(false);
    setView('public');
  };

  // 🔐 LOGIN
  if (view === 'login') {
    return (
      <div className="App">
        <Login onLoginSuccess={handleLoginSuccess} />
      </div>
    );
  }

  // 🛠️ ADMIN
  if (view === 'admin' && isAuth) {
    return (
      <div className="App">
        <AdminPanel onLogout={handleLogout} />
      </div>
    );
  }

  // 🌍 SITIO PÚBLICO
  return (
    <div className="App">
      <Header onAdminClick={handleAdminClick} />
      <Hero />
      <Services />
      <About />
      <Gallery />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;